// src/pages/leads/DncModal.jsx
import React from 'react';
import {
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalCloseButton,
  ModalBody,
  ModalFooter,
  VStack,
  Text,
  Flex,
  Button,
  FormControl,
  FormLabel,
  Select,
  Textarea,
} from '@chakra-ui/react';

/**
 * DncModal
 *
 * Props:
 * - isOpen: boolean
 * - onClose: () => void
 * - dncReasons: string[]
 * - dncReason: string
 * - onChangeDncReason: (v: string) => void
 * - dncNote: string
 * - onChangeDncNote: (v: string) => void
 * - onSubmit: () => void
 */
export default function DncModal({
  isOpen,
  onClose,
  dncReasons = [],
  dncReason = 'Do Not Contact',
  onChangeDncReason,
  dncNote = '',
  onChangeDncNote,
  onSubmit,
}) {
  return (
    <Modal isOpen={isOpen} onClose={onClose} isCentered>
      <ModalOverlay />
      <ModalContent>
        <ModalHeader>Mark as Dead (DNC)</ModalHeader>
        <ModalCloseButton />
        <ModalBody>
          <VStack spacing={4} align="stretch">
            <Text>This will remove the lead from active lists and block future calls/emails.</Text>

            <FormControl>
              <FormLabel fontSize="sm" fontWeight="bold" color="gray.600">
                Reason
              </FormLabel>
              <Select
                size="md"
                value={dncReason}
                onChange={(e) => onChangeDncReason?.(e.target.value)}
              >
                {dncReasons.map((r) => (
                  <option key={r} value={r}>
                    {r}
                  </option>
                ))}
              </Select>
            </FormControl>

            <FormControl>
              <FormLabel fontSize="sm" fontWeight="bold" color="gray.600">
                Notes (optional)
              </FormLabel>
              <Textarea
                value={dncNote}
                onChange={(e) => onChangeDncNote?.(e.target.value)}
                rows={3}
              />
            </FormControl>
          </VStack>
        </ModalBody>

        <ModalFooter>
          <Flex justify="flex-end" pt={4} w="100%">
            <Button variant="ghost" mr={3} onClick={onClose}>
              Cancel
            </Button>
            <Button colorScheme="red" onClick={onSubmit}>
              Confirm
            </Button>
          </Flex>
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
}
